module.exports = {"Add":"Add","Ok":"OK","Cancel":"Cancel","Copy":"Copy","Delete":"Delete","Detail":"Detail","Save":"Save","StartDate":"Start","EndDate":"End","DeleteCurrentRecord":"You are about to delete one or more records.\r\n\r\nIf you click Ok, you won't be able to undo this Delete operation.\r\nAre you sure you want to delete these records?\r\n"}


//////////////////
// WEBPACK FOOTER
// ./src/Core/Stores/TranslationsStore/defaultTranslations.json
// module id = 873
// module chunks = 0